import TagManager from "react-gtm-module";

/**
 * Fire GTM purchase once per checkout session.
 * Uses the analytics payload from payment-status / payment-success
 * (transaction_id prefers P1 Transaction._id).
 *
 * user_data is sent unhashed (email / phone / first_name / last_name)
 * so GTM can hash for Google Ads enhanced conversions if required.
 */
export async function trackSelfSignupPurchase(analytics, { sessionId } = {}) {
  if (!analytics?.transaction_id) return false;

  const dedupeKey = `p1_ga4_purchase_${analytics.transaction_id}`;
  try {
    if (typeof sessionStorage !== "undefined" && sessionStorage.getItem(dedupeKey)) {
      return false;
    }
  } catch (_) {
    // sessionStorage may be unavailable (private mode / iframe restrictions)
  }

  const userData = {};
  const raw = analytics.user_data || {};
  if (raw.email) userData.email = String(raw.email).trim().toLowerCase();
  if (raw.phone) userData.phone = String(raw.phone).trim();
  if (raw.first_name) userData.first_name = String(raw.first_name).trim();
  if (raw.last_name) userData.last_name = String(raw.last_name).trim();

  const items = (analytics.items || []).map((item) => ({
    item_id: item.item_id,
    item_name: item.item_name,
    price: item.price,
    quantity: item.quantity ?? 1,
    item_category: item.item_category || "Membership",
  }));

  TagManager.dataLayer({
    dataLayer: {
      event: "purchase",
      ecommerce: {
        transaction_id: analytics.transaction_id,
        value: analytics.value ?? 0,
        currency: analytics.currency || "AUD",
        items,
      },
      user_data: userData,
      // Extra join keys for GTM / reporting (Frank / backend extract)
      p1_backend_transaction_id: analytics.backend_transaction_id || null,
      p1_stripe_payment_intent: analytics.stripe_payment_intent || null,
      p1_stripe_session_id: analytics.stripe_session_id || sessionId || null,
      p1_stripe_subscription_id: analytics.stripe_subscription_id || null,
    },
  });

  try {
    if (typeof sessionStorage !== "undefined") {
      sessionStorage.setItem(dedupeKey, "1");
    }
  } catch (_) {
    // ignore
  }

  return true;
}
